import { FORM, STRINGS } from '../../constants';

export const HELP_TYPES = {
  CHAT: 'chat',
  ISSUE: 'issue',
};

export const HELP_SERVICE_TYPES = {
  SAMEDAY: 'sameday',
  DPD_ONLINE: 'dpdOnline',
};

export const CITYSPRINT_HELP_FIELDS = {
  BOOKING_REFERENCE: {
    KEY: 'citysprintBookingReference',
    LABEL: STRINGS.HELP_SAMEDAY_BOOKING_REFERENCE_LABEL,
  },
  DELIVERY_POSTCODE: {
    KEY: 'citysprintDeliveryPostcode',
    LABEL: STRINGS.HELP_SAMEDAY_DELIVERY_POSTCODE_LABEL,
  },
};

export const CONTACT_US_TYPE = {
  CHAT: 'Chat',
};

export const SEARCH_FIELD_SET = {
  COLLECTION: 'collection',
  DELIVERY: 'delivery',
};

export const SEARCH_FIELDS = {
  [SEARCH_FIELD_SET.COLLECTION]: [
    FORM.HELP_FIELDS.COLLECTION_REFERENCE.KEY,
    FORM.HELP_FIELDS.COLLECTION_POSTCODE.KEY,
  ],
  [SEARCH_FIELD_SET.DELIVERY]: [
    FORM.HELP_FIELDS.PARCEL_NUMBER.KEY,
    FORM.HELP_FIELDS.POSTCODE_OR_ORDER_ID.KEY,
  ],
};

export const MULTILINE_FIELDS = [
  FORM.HELP_KEYS.PACKAGE_DESCRIPTION,
  FORM.HELP_KEYS.ADDITIONAL_INFORMATION,
  FORM.HELP_KEYS.DAMAGE_DESCRIPTION,
  FORM.HELP_KEYS.MISSING_DESCRIPTION,
  FORM.HELP_KEYS.DAMAGED_ITEM,
];

export const FIELDS_TO_RESET = [
  FORM.HELP_KEYS.PARCEL_CONTENTS,
  FORM.HELP_KEYS.GOODS_VALUE,
  FORM.HELP_KEYS.PACKAGE_DESCRIPTION,
  FORM.HELP_KEYS.ADDITIONAL_INFORMATION,
  FORM.HELP_KEYS.DAMAGED_ITEM,
  FORM.HELP_KEYS.DAMAGE_DESCRIPTION,
  FORM.HELP_KEYS.MISSING_DESCRIPTION,
  FORM.HELP_KEYS.ATTACHED_IMAGES,
];

export const FIELDS_TO_RESET_ON_PARCEL_CHANGE = [
  ...FIELDS_TO_RESET,
  FORM.HELP_FIELDS.ISSUE_TYPE.KEY,
  `${FORM.HELP_KEYS.CONTACT_DETAILS}.name`,
  `${FORM.HELP_KEYS.CONTACT_DETAILS}.email`,
  `${FORM.HELP_KEYS.CONTACT_DETAILS}.phone`,
  FORM.HELP_KEYS.ATTACHED_IMAGES,
];

export const ACCEPT_IMAGE_MIME_TYPE = {
  'image/svg+xml': [],
  'image/png': [],
  'image/jpeg': [],
  'image/gif': [],
};

export const MAX_IMAGES_UPLOAD_LIMIT = 4;

export const MAX_IMAGE_SIZE = 5 * 1024 * 1024; // 5Mb

export const COMPRESSION_OPTIONS = {
  maxSizeMB: 2,
  useWebWorker: true,
};
